import React, {useState} from 'react';
import {Box, Typography, Tabs, Tab} from '@mui/material';
import PartnerDashboardShell from '../components/PartnerDashboard.comp';
import AcquisitionTab from '../tabs/Acquisition.tab';
import ImprovementTab from '../tabs/Improvement.tab';
import IntentionForChangeTab from '../tabs/IntentionForChange.tab';

const NAVY   = '#052F44';
const ORANGE = '#FF6900';
const TEAL   = '#1B6B55';

/* ── Per-tab metadata ───────────────────────────────────────────── */
const TAB_LABELS      = ['Acquisition', 'Improvement', 'Intention for Change'];
const TAB_SUBTITLES   = [
    'Where is competency acquisition strongest or weakest?',
    'Which cohorts, modules, or groups show lower improvement?',
    'Which cohorts show lower intention to change after the program?',
];
const TAB_TITLES      = ['Competency Acquisition', 'Competency Improvement', 'Intention for Change'];
const TAB_BREADCRUMBS = ['Acquisition', 'Improvement', 'Intention for Change'];

/* ── Main page ──────────────────────────────────────────────────── */
const CompetencyPage = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <PartnerDashboardShell
            tabs={
                <Tabs
                    value={activeTab}
                    onChange={(_, v) => setActiveTab(v)}
                    TabIndicatorProps={{style: {backgroundColor: ORANGE}}}
                    sx={{
                        borderBottom: '1px solid #E5E7EB',
                        mb: 1,
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '14px',
                            color: '#6A7282',
                            px: 2,
                        },
                        '& .Mui-selected': {color: `${ORANGE} !important`},
                    }}
                >
                    <Tab label="Acquisition"/>
                    <Tab label="Improvement"/>
                    <Tab label="Intention for Change"/>
                </Tabs>
            }
        >
            {/* Title */}
            <Typography sx={{fontSize: '23px', fontWeight: 800, color: NAVY, mb: 0.5, mt: 1.5}}>
                {TAB_TITLES[activeTab]}
            </Typography>

            {/* Subtitle */}
            <Box sx={{mb: 3}}>
                <Typography sx={{fontSize: '14px', fontStyle: 'italic', color: '#4B5563'}}>
                    {TAB_SUBTITLES[activeTab]}
                </Typography>
            </Box>

            {activeTab === 0 && <AcquisitionTab/>}
            {activeTab === 1 && <ImprovementTab/>}
            {activeTab === 2 && <IntentionForChangeTab/>}

        </PartnerDashboardShell>
    );
};

export default CompetencyPage;
